import { List } from "rsuite";
import styled from "styled-components";


export const Container = styled(List.Item)`
    background-color: ${({ montagemProduto, theme }) => montagemProduto
        ? theme.colors.primary
        : theme.colors.backgroundSecondary};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
`

export const Description = styled.div`
    color: ${({ isUsing, theme }) => isUsing ? theme.colors.white : theme.colors.text};
    font-size: 18px;
    padding: 10px 0px;
    flex-grow: 1;
    cursor: pointer;
`;